import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { detectLanguageRequest } from '../requests';

export const useLanguageDetection = (
  { type, id, attribute, text, lang },
  { staleTime = ms('1h'), enabled = true } = {},
) => {
  const {
    data = {},
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['translations', 'detect', type, id, attribute, text, lang],
    queryFn: () => detectLanguageRequest({ type, id, attribute, text, lang }),
    staleTime,
    enabled,
    retry: false,
  });

  return {
    ...data,
    isLoading,
    isError,
  };
};
